import React from "react";
import LegalLayout, { Section } from "@/pages/legal/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026" testid="privacy-page">
      <Section title="1. Data we collect">
        <p>We collect only what we need to run the service:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Account data</strong> — your email address and name from Google sign-in.</li>
          <li><strong>Workspace content</strong> — the brand details, prompts, and post content you create.</li>
          <li><strong>Payment metadata</strong> — subscription status and billing metadata processed via Stripe.</li>
          <li><strong>Usage data</strong> — basic product usage (e.g., posts generated) to enforce plan limits.</li>
        </ul>
      </Section>
      <Section title="2. Payments are handled by Stripe">
        <p>
          All payments are processed by Stripe, Inc. Your card and payment credentials are entered directly with
          Stripe and are <strong>never stored on AutoGridSocial servers</strong>. We only retain a
          Stripe customer reference and your subscription status.
        </p>
      </Section>
      <Section title="3. How we use your data">
        <p>
          We use your data to provide and improve the service, generate and schedule your posts, process billing,
          send transactional and product emails, and provide support. We do not sell your personal data.
        </p>
      </Section>
      <Section title="4. Third-party processors">
        <p>
          We share data only with processors required to operate the service: Stripe (payments), our email provider
          (transactional email), our LLM/image providers (to generate content you request), and the social dispatch
          provider you connect for scheduling. Each processes data only to perform its function.
        </p>
      </Section>
      <Section title="5. Your rights (GDPR / CCPA)">
        <p>
          You have the right to access, correct, export, or delete your personal data, and to object to or restrict
          certain processing. California residents have the right to know what personal information is collected and
          to request its deletion, and we do not sell personal information. To exercise any right, email{" "}
          <a href="mailto:beckettseb367@gmail.com" className="underline hover:text-foreground">beckettseb367@gmail.com</a>.
        </p>
      </Section>
      <Section title="6. Data retention & deletion">
        <p>
          We retain your data while your account is active. On account deletion request, we remove your account data
          and workspace content within 30 days, except where retention is required by law (e.g., tax records held by
          our payment processor).
        </p>
      </Section>
      <Section title="7. Security">
        <p>
          We use industry-standard measures to protect your data in transit and at rest. No method of transmission or
          storage is 100% secure, but we work to protect your information and promptly address vulnerabilities.
        </p>
      </Section>
    </LegalLayout>
  );
}
